import { TFuncKey, Trans } from 'react-i18next'

interface ListTransProps {
  translationPath: string
}

export const ListTrans = ({ translationPath }: ListTransProps) => {
  return <Trans i18nKey={translationPath as TFuncKey} components={{ li: <li />, ul: <ul />, ol: <ol /> }} />
}
